import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'wonderbly-components/lib/Icon';
import './Basket.scss';
import Contents from './Contents';

const Basket = props => (
  <div>
    <a
      href={props.href}
      onClick={props.handleClick}
      className={cx('basket-link', { 'basket-link-solo': props.isSolo })}>
      <div className="basket-link-text">{props.linkText}</div>
      <div className="basket-link-icon">
        <Icon icon={props.icon} />
        <span className="basket-link-number">{props.count}</span>
      </div>
    </a>
    {props.isOpen && (
      <Contents onClose={props.handleClick} href={props.href} />
    )}
  </div>
);

Basket.propTypes = {
  href: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  isSolo: PropTypes.bool,
  linkText: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default Basket;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/Basket/Basket.js